import styled, { css } from 'styled-components';
export const AlertBase = styled.div.attrs({
    className: 'alert',
}) `

  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  max-width: 560px;
  min-width: 288px;

  ${({ fluid }) => (fluid && css `
      width: 100%;
      max-width: 100%;
    `)}

  background: var(--color-info-background);

  outline: 3px dashed;
  outline-offset: -3px;
  outline-color: var(--color-info-accent);

  & > i {
    flex-shrink: 0;
    align-self: flex-start;

    margin: 16px;
    font-size: 24px;
    line-height: 24px;
    color: var(--color-info-accent);
  }

  ${({ variant }) => (variant === 'error' && css `
      background: var(--color-error-background);
      outline-color: var(--color-error-accent);

      & > i {
        color: var(--color-error-accent);
      }
    `)}

  ${({ variant }) => (variant === 'warning' && css `
       background: var(--color-warning-background);
      outline-color: var(--color-warning-accent);

      & > i {
        color: var(--color-warning-accent);
      }
    `)}

  ${({ variant }) => (variant === 'success' && css `
      background: var(--color-success-background);
      outline-color: var(--color-success-accent);

      & > i {
        color: var(--color-success-accent);
      }
    `)}
`;
export const Container = styled.div `
  max-width: 100%;
  align-self: flex-start;
`;
export const Title = styled.div `
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 16px 24px 16px 0;
`;
export const Description = styled.div `
  font-size: 14px;
  line-height: 24px;
  margin: 24px 24px 16px 0;

  & > a {
    color: var(--color-on-background);
    font-size: 14px;
    line-height: 24px;
  }
`;
